import { useNavigate } from "react-router-dom";
import ajaxStations from "../../util/remote/ajaxStations";
import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxStationOwners from "../../util/remote/ajaxStationOwners";
import ajaxStationsGroups from "../../util/remote/ajaxStationsGroups";
const RegisterStationModal = (props) => {
  var company_id = Number(window.localStorage.getItem("FuelFy@company_id"));
  console.log();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [ownerID, setOwnerID] = useState(company_id);
  const [groupID, setgroupID] = useState(null);
  const [stationName, setStationName] = useState("");
  const [location, setLocation] = useState("");
  // validation
  const allRowsFilled = () => ownerID && stationName && location;
  // submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const data = {
      station_owner_id: ownerID,
      station_name: stationName,
      location: location,
      groupID: groupID.value,
    };
    setLoading(true);
    const response = await ajaxStations.createstation(data);
    setLoading(false);
    if (response.status === "OK") {
      props.func();
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setOwnerID(null);
    setStationName("");
    setLocation("");
  };
  // Fetch Owners
  const [stationOwners, setStationOwners] = useState([]);
  const fetchData = async () => {
    const server_response =
      await ajaxStationOwners.liststation_owners_mini_data({});
    if (server_response.status === "OK") {
      const list =
        Array.isArray(server_response.details) &&
        server_response.details.map((d) => ({
          value: Number(d.id),
          label: d.name,
        }));
      setStationOwners(list);
    } else {
      toast.error(server_response.message);
    }
  };
  const [groupList, setgroupList] = useState([]);
  const fetchGroups = async () => {
    setLoading(true);
    const response = await ajaxStationsGroups.list_stations_groups();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: d.id,
          label: d.group_name,
        }));
      setgroupList(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
    fetchGroups();
  }, []);
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e, controls.close)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Station"}
      </button>
    </>
  );
  return (
    <SystemModal title="Creating Fuel Station" size="md" footer={RenderFooter}>
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register Fuel Station</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Owner */}
                    <div className="col-md-12">
                      <label>
                        Station Owner <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stationOwners}
                        value={
                          stationOwners.find(
                            (s) => s.value === Number(ownerID)
                          ) || null
                        }
                        isDisabled={true} // <-- disabled but shows the value
                        onChange={(selected) => setOwnerID(selected.value)}
                        placeholder="Select station owner"
                      />
                    </div>
                    {/* Owner */}
                    <div className="col-md-12">
                      <label>
                        Station Group <span style={{ color: "red" }}></span>
                      </label>
                      <Select
                        options={groupList}
                        value={groupID}
                        onChange={setgroupID}
                        placeholder="Select station group"
                      />
                    </div>
                    {/* Station Name */}
                    <div className="col-md-12">
                      <label>
                        Station Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={stationName}
                        onChange={(e) => setStationName(e.target.value)}
                        className="form-control"
                        placeholder="Enter station name"
                        required
                      />
                    </div>
                    {/* Location */}
                    <div className="col-md-12 mt-3">
                      <label>
                        Location <span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        className="form-control"
                        placeholder="Enter station location"
                        rows={2}
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterStationModal;
